import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {
    Column,
    ColumnType,
    DataTable,
    DataTableOptions,
    DataTableData,
    SortDirection
} from './components/DataTable/DataTable';

/**
 * Creates an Orchard DataTable
 * @param id The id of the div element to build the data table in
 * @param options The options object
 * @param refCallback A callback executed once rendering is complete, providing a reference to the DataTable component
 */
export function render<T extends DataTableData>(
    id: string,
    options: DataTableOptions<T>,
    refCallback: (component: DataTable<T>) => void
) {
    ReactDOM.render(
        <DataTable {...options} idSuffix={id} ref={refCallback} />,
        document.getElementById(id) as HTMLElement
    );
}

export {
    Column,
    ColumnType,
    DataTable,
    DataTableOptions,
    DataTableData,
    SortDirection
};
